import { render, staticRenderFns } from "./myInvitationCode.vue?vue&type=template&id=46e23994&scoped=true&"
import script from "./myInvitationCode.vue?vue&type=script&lang=js&"
export * from "./myInvitationCode.vue?vue&type=script&lang=js&"
import style0 from "./myInvitationCode.vue?vue&type=style&index=0&id=46e23994&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e23994",
  null
  
)

export default component.exports